import React from 'react';
import { components } from 'react-select';
import { FAIcon } from '../../fa-icon';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import { MaterialCheckbox } from '../../../material/MaterialCheckbox';

const { Option } = components;

export const SelectCheckboxOption = props => {
  const {
    isMulti,
    isSelected,
    data,
    selectOption,
    label,
    innerRef,
    innerProps,
    multi,
    selectProps,
    useRightCheckmark,
    helperText,
  } = props;
  const formattedName = selectProps?.name?.replace?.('[]', '') ?? '';
  const name = formattedName ? `-${formattedName}` : '';
  const optionIndex = selectProps?.options?.map?.(option => option?.label)?.indexOf?.(label);
  const dataAction = `select-option-${kebabCase(label)}`;
  const dataObjectId = `Select${name}-option-${optionIndex}`;
  const multiSelect = isMulti || multi;

  const handleSelect = e => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    selectOption(data);
  };

  const handleKeyDown = e => {
    if (e.key === ' ' || e.key === 'Enter') {
      handleSelect(e);
    }
    innerProps.onKeyDown?.(e);
  };

  const multiSelectCheckbox = () => {
    return <MaterialCheckbox helpLine={helperText} checked={isSelected} {...props} />;
  };
  const singleSelectOption = () => {
    return (
      <>
        <label>
          {label}
          {!!helperText && <div className="helper-text">{helperText}</div>}
        </label>

        {isSelected && useRightCheckmark && (
          <>
            <div style={{ position: 'absolute', right: '15px', top: '20%' }}>
              <FAIcon icon="check" />
            </div>
          </>
        )}
      </>
    );
  };
  return (
    <div
      data-action={dataAction}
      data-object-id={dataObjectId}
      style={{ position: 'relative' }}
      ref={innerRef}
      {...innerProps}
      onKeyDown={handleKeyDown}
      onMouseDown={handleSelect}
    >
      {multiSelect ? <>{multiSelectCheckbox()} </> : <Option {...props}>{singleSelectOption()}</Option>}
    </div>
  );
};

SelectCheckboxOption.propTypes = {
  helperText: PropTypes.string,
  isMulti: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  multi: PropTypes.bool,
  useRightCheckmark: PropTypes.bool,
  selectProps: PropTypes.shape({
    name: PropTypes.string,
    options: PropTypes.array,
  }),
};
